import { useCustomMutation } from "@refinedev/core";
import { notification } from "antd";
import { PROCUREMENT_PLAN_REPORT_SUBMIT_MUTATION } from "../queries";

interface SubmitResponse {
  report: any;
  wasSubmitted: boolean;
  message: string;
}

interface UseSubmitProcurementPlanReportProps {
  onSuccess?: (data: SubmitResponse) => void;
  onError?: (error: any) => void;
}

export const useSubmitProcurementPlanReport = ({
  onSuccess,
  onError
}: UseSubmitProcurementPlanReportProps = {}) => {
  const { mutate: submitProcurementPlanReport, isLoading } = useCustomMutation<SubmitResponse>();

  const submit = async (input: { reportId: string }) => {
    try {
      submitProcurementPlanReport({
        meta: {
          gqlMutation: PROCUREMENT_PLAN_REPORT_SUBMIT_MUTATION,
        },
        values: { input },
        url: "",
        method: "post"
      }, {
        onSuccess: (data) => {
          // Handle Refine's response structure - the actual data is nested
          const response = (data as any)?.data?.submitProcurementPlanReport || data;

          // Successfully submitted
          notification.success({
            message: 'Report Submitted Successfully',
            description: 'The procurement plan report has been submitted for approval.',
          });
          onSuccess?.(response);
        },
        onError: (error) => {
          notification.error({
            message: 'Submission Failed',
            description: error.message || 'Failed to submit the procurement plan report.',
          });
          onError?.(error);
        }
      });
    } catch (error) {
      console.error('Error submitting procurement plan report:', error);
      onError?.(error);
    }
  };

  return {
    submit,
    isLoading
  };
};